import React, { ReactNode, useState } from "react";
import "./YearIndicator.scss";
import { sceneCount } from "../../../App";
import { YearIndicatorSvg } from "../YearIndicatorSvg/YearIndicatorSvg";

interface IProps {
    children: ReactNode;
    year: number;
    changeSliderValue: (action: 'increase' | 'decrease') => void;
    showClimateInfo: boolean;
    climateInfo: ReactNode;
    visible: boolean;
    setSliderValue: (value: number) => void;
    sliderValue: number;
}

export function YearIndicator({ year, children, changeSliderValue, showClimateInfo, climateInfo, visible, setSliderValue, sliderValue }: IProps) {
    // @ts-ignore
    const isTouchDevice = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
    const [clickAction, setClickAction] = useState<'increase' | 'decrease' | undefined>(undefined);


    return (
        <div className={`year-indicator-wrapper ${showClimateInfo ? 'show-climate-info' : ''} ${visible ? 'visible' : ''}`} data-active={year} data-click={clickAction}>
            <div className="indicator-container">
                {(new Array(sceneCount + 1)).fill(0).map((nothing, index) => {
                    const yearPlaceholder = (2020 + 5 * index) - (!(index %2) ? 0 : 5);
                    return <div className="indicator" key={index}>
                        <h1>{yearPlaceholder}</h1>
                        <span>{!(index %2) ? 'summer' : 'winter'}</span>
                    </div>
                })}
            </div>
            <div className="click-sides">
                <div
                    className={`click-side ${year === 2020 ? 'disabled' : ''}`}
                    onMouseDown={year === 2020 ? () => {} : () => {
                        setClickAction('decrease');
                    }}
                    onTouchStart={year === 2020 ? () => {} : () => {
                        setClickAction('decrease');
                    }}
                    onMouseUp={() => {
                        setClickAction(undefined);
                        if (year > 2020 && !isTouchDevice) {
                            changeSliderValue('decrease');
                        }
                    }}
                    onTouchEnd={() => {
                        setClickAction(undefined);
                        if (year > 2020 && isTouchDevice) {
                            changeSliderValue('decrease');
                        }
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="480" height="240" viewBox="0 0 480 240">
                        <defs>
                            <radialGradient id="radial-gradient-x" cx="0" cy="0.5" r="1" gradientTransform="translate(0 0.235) scale(1 0.529)" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#fff" stopOpacity="0"/>
                                <stop offset="1" stopColor="#fff"/>
                            </radialGradient>
                            <clipPath id="clip-path-x">
                                <rect id="Rectangle_63" data-name="Rectangle 63" width="240" height="480" fill="url(#radial-gradient-x)"/>
                            </clipPath>
                        </defs>
                        <g id="Group_41" data-name="Group 41" transform="translate(120 -120)" opacity="0.997">
                            <g id="Group_40" data-name="Group 40" transform="translate(-120 360) rotate(-90)" clipPath="url(#clip-path-x)">
                                <path id="Path_14" data-name="Path 14" d="M240,240C240,372.548,132.548,480,0,480V0C132.548,0,240,107.452,240,240" fill="url(#radial-gradient-x)"/>
                            </g>
                        </g>
                    </svg>
                </div>
                <div
                    className={`click-side ${year === 2085 ? 'disabled' : ''}`}
                    onMouseDown={year === 2085 ? () => {} : () => {
                        setClickAction('increase');
                    }}
                    onTouchStart={year === 2085 ? () => {} : () => {
                        setClickAction('increase');
                    }}
                    onMouseUp={() => {
                        setClickAction(undefined);
                        if (year < 2085 && !isTouchDevice) {
                            changeSliderValue('increase');
                        }
                    }}
                    onTouchEnd={() => {
                        setClickAction(undefined);
                        if (year < 2085 && isTouchDevice) {
                            changeSliderValue('increase');
                        }
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="480" height="240" viewBox="0 0 480 240">
                        <defs>
                            <radialGradient id="radial-gradient-y" cx="0" cy="0.5" r="1" gradientTransform="translate(0 0.235) scale(1 0.529)" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#fff" stopOpacity="0"/>
                                <stop offset="1" stopColor="#fff"/>
                            </radialGradient>
                            <clipPath id="clip-path-y">
                                <rect id="Rectangle_63" data-name="Rectangle 63" width="240" height="480" fill="url(#radial-gradient-y)"/>
                            </clipPath>
                        </defs>
                        <g id="Group_46" data-name="Group 46" transform="translate(241 240) rotate(180)" opacity="0.997">
                            <g id="Group_40" data-name="Group 40" transform="translate(-239 240) rotate(-90)" clipPath="url(#clip-path-y)">
                                <path id="Path_14" data-name="Path 14" d="M240,240C240,372.548,132.548,480,0,480V0C132.548,0,240,107.452,240,240" fill="url(#radial-gradient-y)"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>

            <YearIndicatorSvg
                topEnabled={!showClimateInfo && year > 2020}
                bottomEnabled={!showClimateInfo && year < 2085}
                showBall={!showClimateInfo}
                setSliderValue={setSliderValue}
                sliderValue={sliderValue}
            />

            <div className="timeline-legend">
                <div className="timeline-legend-item timeline-start">
                    <span>Year</span>
                    <span>2020</span>
                </div>
                <div className="timeline-legend-item timeline-end">
                    <span>2080</span>
                    <span>timeline</span>
                </div>
            </div>
            <div className="year-indicator-children-wrapper">
                {children}
            </div>
            <div className="climate-info-container">
                {climateInfo}
            </div>
            {/*<svg xmlns="http://www.w3.org/2000/svg" width="550" height="550" viewBox="0 0 550 550">*/}
            {/*    <rect id="Rectangle_80" data-name="Rectangle 80" width="550" height="550" fill="transparent"/>*/}
            {/*    <g id="Group_61" data-name="Group 61" transform="translate(24 27)" clipPath="url(#clip-path)">*/}
            {/*        <path id="Path_19" data-name="Path 19" d="M280.059,496.391a1,1,0,0,1-.118-1.993C404.255,479.437,498,373.6,498,248.2c0-125.454-93.8-231.3-218.177-246.21a1,1,0,1,1,.238-1.985C405.447,15.037,500,121.737,500,248.2c0,126.4-94.5,233.1-219.821,248.181a.964.964,0,0,1-.12.007" fill="#fff"/>*/}
            {/*        <path id="Path_20" data-name="Path 20" d="M220.178,496.418a.966.966,0,0,1-.119-.007C94.605,481.435,0,374.728,0,248.2,0,121.737,94.554,15.036,219.94.007a1,1,0,1,1,.238,1.986C95.8,16.9,2,122.749,2,248.2,2,373.715,95.847,479.568,220.295,494.425a1,1,0,0,1-.117,1.993" fill="#fff"/>*/}
            {/*    </g>*/}
            {/*    <g data-name="arrow-up">*/}
            {/*        <path id="Polygon_6" data-name="Polygon 6" d="M11,0,22,18H0Z" transform="translate(263 15)" fill="#fff"/>*/}
            {/*    </g>*/}
            {/*    <g data-name="arrow-down">*/}
            {/*        <path id="Polygon_7" data-name="Polygon 7" d="M11,0,22,18H0Z" transform="translate(285 535) rotate(180)" fill="#fff"/>*/}
            {/*    </g>*/}
            {/*</svg>*/}
            {/*<div className="top-line" />*/}
            {/*<div className="bottom-line" />*/}



        </div>
    )
}
